var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "145px",
    viewBox: "0 0 104 145",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "complete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-Procedure-Documents",
    transform: "translate(-1320.000000, -248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "The-simplest-way",
    transform: "translate(382.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "complete",
    transform: "translate(938.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards/shop/thankYou"
  }, /*#__PURE__*/React.createElement("g", {
    id: "squares/card",
    fill: "#FBFBFB",
    stroke: "#D3D3D3",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.25,
    y: 0.25,
    width: 103.5,
    height: 117.5,
    rx: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "text/titleGray",
    transform: "translate(37.960000, 9.440000)",
    fill: "#C0C0C0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 51,
    height: 6,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "text/singleMedGray",
    transform: "translate(50.960000, 18.880000)",
    fill: "#EAEAEA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 26,
    height: 5,
    rx: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "text/singleMedGray",
    transform: "translate(15.080000, 33.040000)",
    fill: "#EAEAEA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 31,
    height: 4,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "premade/imageThumbWhite",
    transform: "translate(17.160000, 8.850000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/blankMedGray",
    fill: "#EAEAEA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0,
    y: 0,
    width: 14,
    height: 16,
    rx: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/imageWhite",
    transform: "translate(2.100000, 4.800000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    points: "4.42857143 2.4 7 5.7 1.85714286 5.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    points: "3.07140996 2.0504574 5.88262895 5.7 0.260190982 5.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92847905,1.02999945 C8.81714517,4.14333315 9.76147823,5.7 9.76147823,5.7 C9.76147823,5.7 4.09547987,5.7 4.09547987,5.7 C4.09547987,5.7 5.03981293,4.14333315 6.92847905,1.02999945 Z",
    id: "Triangle"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2",
    cx: 4.57142857,
    cy: 1.05,
    rx: 1,
    ry: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "text/singleMedGray",
    transform: "translate(15.600000, 70.210000)",
    fill: "#EAEAEA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 73,
    height: 6,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "text/singleBlack",
    transform: "translate(16.120000, 57.820000)",
    fill: "#F4F4F4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 42,
    height: 6,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "text/singleMedGray",
    transform: "translate(15.600000, 79.650000)",
    fill: "#EAEAEA"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 31,
    height: 6,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "text/titleGray",
    transform: "translate(15.600000, 42.480000)",
    fill: "#C0C0C0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 73,
    height: 9,
    rx: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(26.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#25D8CA",
    cx: 26.3673469,
    cy: 26.3673469,
    r: 26.3673469
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-symbol",
    transform: "translate(17.000000, 19.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "5.72727273 11.0375696 1.43181818 6.66419295 0 8.12198516 5.72727273 13.953154 18 1.45779221 16.5681818 0"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.d5fba8a90886a760b61d9bb42ecb159d.svg";
export { ForwardRef as ReactComponent };